import { Injectable } from '@angular/core';
import { INDDReportCurrencyProvider } from '@ndk/ng-reports/config';
import { LocalStorageService } from '@ndk/ng-storage';

import { LocalStorageKeys } from '@core/storage/local-storage.enum';

@Injectable()
export class ReportCurrencyService implements INDDReportCurrencyProvider {
    constructor(private localStorage: LocalStorageService) { }

    public getCurrencyCulture(): string { // TODO: criar testes de unidade
        return this.localStorage.getValue(LocalStorageKeys.CurrencyCulture);
    }
}
